import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-inherit-dialog',
  templateUrl: './inherit-dialog.component.html',
  styleUrls: ['./inherit-dialog.component.scss']
})
export class InheritDialogComponent implements OnInit {

  @Input() visible: boolean = false;
  @Input() timing: boolean = false;
  @Input() title: string = '';
  @Input() mode: string = '';
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() okClicked = new EventEmitter<boolean>();

  public form: UntypedFormGroup = this.fb.group({
    include: new UntypedFormControl(false)
  });

  constructor(
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.okClicked.emit(this.form.get('include').value);
    this.closeDialog();
  }

  onCancel(): void {
    this.closeDialog();
  }

  private closeDialog(): void {
    this.visibleChange.emit(false);
    this.initForm();
  }

  private initForm(): void {
    this.form.patchValue({
      include: false
    });
  }

}
